"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Add = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#1F1F1F' : _b, _c = _a.scale, scale = _c === void 0 ? 1 : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 2 : _d;
    return (react_1.default.createElement("svg", { width: scale * 32, height: scale * 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("rect", { x: "0.5", y: "0.5", width: "31", height: "31", rx: "15.5", fill: color }),
        react_1.default.createElement("path", { d: "M16 9V23", stroke: "#fff", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M9 16H23", stroke: "#fff", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("rect", { x: "0.5", y: "0.5", width: "31", height: "31", rx: "15.5", stroke: "#fff" })));
};
exports.default = Add;
//# sourceMappingURL=Add.js.map